import Component from './Component';
// Define some eslint global variables
/* global debugLog, digitalData:writable, _satellite:writable */

// DataEvents for analytics

export default class DataEvents extends Component {
  load() {
    this.initDataEvents();
    super.load();
  }

  initDataEvents() {
    // console.log('DataEvents!');

    let watchSubCategory;
    let watchSearchGrid;
    const whenPreviousAction = [];

    // define if undefined
    if (!window.digitalData) {
      console.log("DigitalData is defined");
      window.digitalData = {};
    }

    // Setup event listeners for menu item clicks ('.main-nav-item')
  const navItems = document.querySelectorAll('.main-nav-item');
  if (navItems.length) {
    navItems.forEach(element => {
      element.addEventListener('click', function () {
        // Find the text span within the clicked button
        const textSpan = this.querySelector('.main-nav-item-text');
        
        if (textSpan && textSpan.textContent) {
          const menu = {
            'linkName': textSpan.textContent.trim()
          };
          window.digitalData.menu = menu;
          debugLog('digitalData.menu: ', window.digitalData.menu);
          
          if (!location.hostname.includes('local')) {
            _satellite.track('menuClick');
          }
        }
      });
    });
  }

  // Setup dynamic tracking for sub-menu and card elements using event delegation
  const setupDynamicTracking = () => {
    // Use event delegation on the nav container to catch dynamically loaded elements
    const navContainer = document.querySelector('.nav-builder') || document.body;
    
    navContainer.addEventListener('click', function(event) {
      // Handle sub-toggle clicks
      const subToggle = event.target.closest('.sub-toggle');
      if (subToggle) {
        const linkText = subToggle.querySelector('.link-text');
        if (linkText && linkText.textContent) {
          const menu = {
            'linkName': linkText.textContent.trim()
          };
          window.digitalData.menu = menu;
          debugLog('digitalData.menu (sub-toggle): ', window.digitalData.menu);
          
          if (!location.hostname.includes('local')) {
            _satellite.track('menuClick');
          }
        }
      }
      
      // Handle card link clicks
      const cardLink = event.target.closest('.card-link');
      if (cardLink) {
        const cardTitle = cardLink.querySelector('.card-title');
        console.log('cardLink', cardTitle);
        if (cardTitle && cardTitle.textContent) {
          const menu = {
            'linkName': cardTitle.textContent.trim()
          };
          window.digitalData.menu = menu;
          debugLog('digitalData.menu (card): ', window.digitalData.menu);
          
          if (!location.hostname.includes('local')) {
            _satellite.track('menuClick');
          }
        }
      }
    });
    
    console.log('Dynamic tracking setup with event delegation');
  };

  // Initialize dynamic tracking
  setupDynamicTracking();

  // Setup card tracking after a delay to catch dynamically loaded content
  const setupDelayedCardTracking = () => {
    setTimeout(() => {
      const cardLinks = document.querySelectorAll('.card-link');
            
      cardLinks.forEach(element => {
        
        // Check if already has listener to avoid duplicates
        if (!element.hasAttribute('data-tracking-added')) {
          element.setAttribute('data-tracking-added', 'true');
          element.addEventListener('click', function () {
            const cardTitle = this.querySelector('.card-title');
            console.log("cardTitle:-", cardTitle);
            if (cardTitle && cardTitle.textContent) {
              const menu = {
                'linkName': cardTitle.textContent.trim()
              };
              window.digitalData.menu = menu;
              debugLog('digitalData.menu (delayed card): ', window.digitalData.menu);
              
              if (!location.hostname.includes('local')) {
                _satellite.track('menuClick');
              }
            }
          });
        }
      });
    }, 1500); // Wait 1.5 seconds for content to load
  };

// Also setup delayed tracking as backup
setupDelayedCardTracking();

    /*
      Legacy link tracker
      Needs to confirm with Ed if we are using this for TDU or TA because they do not use the new Nav at the moment
      TODO: Possibly to delete the navs below
      ED response, this is still needed for other websites using the old nav elements.
    */

    // Setup event listners for menu link clicks ('.nav-link')
    const navLinks = document.querySelectorAll('.nav-link');
    if (navLinks.length) {
      navLinks.forEach(element => {

        element.addEventListener('click', function () {
          const elNodes = this.childNodes;
          console.log('.nav-link childNodes: ', elNodes);
          elNodes.forEach((x) => {
            if (x.localName === 'span') {
              // console.log('.nav-link innerHTML: ', x.innerHTML);
              const menu = {
                'linkName': x.innerHTML
              };
              window.digitalData.menu = menu;
              debugLog('digitalData.menu: ', window.digitalData.menu);
              if (!location.hostname.includes('local')) {
                _satellite.track('menuClick');
              }
            }
          });

        });

      });
    }


      // Setup event listeners for submenu link clicks ('.submenu__menu-link')
      const subLinks = document.querySelectorAll('.submenu__menu-link');
      if (subLinks.length) {
        subLinks.forEach(element => {

          element.addEventListener('click', function () {
            // event.preventDefault();
            const elNodes = this.childNodes;
            // console.log('elNodes: ', elNodes);
            elNodes.forEach((x) => {
              const submenu = {
                'linkName': x.textContent
              };
              window.digitalData.menu = submenu;
              debugLog('digitalData.menu: ', window.digitalData.menu);
              if (!location.hostname.includes('local')) {
                _satellite.track('menuClick');
              }
              // alert('clicked .submenu__menu-link ');
            });

          });
        });
      }


    // Personas digitalData.page.pageInfo.affinityCategory and affinityVariable are now handled in the backend _Layout.cshtml template.


    // wait for full page load before running //not an urgent task
    window.onload = (event) => {

      // searchFilter clicks ('#search-filters-type')
      const searchFiltersTray = document.getElementById('search-filters-tray');
      if (searchFiltersTray) {

        // Options for the observers (which mutations to observe)
        const config = { attributes: true, childList: false, subtree: false };

        observeSearchGrid({ attributes: true, childList: false, subtree: true });
        // console.log('try observeSubCategory() ');
        observeSubCategory(config);
        observeCategory(config);
        observeRegion({ attributes: false, childList: true, subtree: true });

      }

      // debugLog('FIRST getSubCategories()');
      const oldData = Object.assign({}, window.digitalData?.search);  // only does a shallow copy
      getCategories(oldData);
      getSubCategories();  // getSubCategories also triggers get categories
      getRegion(oldData);
      const newData = window.digitalData?.search;
      // console.log('oldData: ', oldData);
      // console.log('newData: ', newData);
      trackSearchFilterChange(oldData, newData);
      setHashEmailDigitalData();
      getNewsLetterSignUpEmailToHash();
    };

    function cleanString(string) {
      const regexTab = /\t/g;
      const regexSpace = /\s/g;
      const regexComma = /,/g;
      return string.trim().replace(regexTab, '').replace(regexSpace, '-').replace(regexComma, '_');
    }

    function setHashEmailDigitalData() {
      const url = new URL(window.location.href);
      const paramValue = url.searchParams.get("utm_email");
        
      if (paramValue && typeof paramValue === 'string') {
        // Regular expression to check if the string is a SHA-256 hash
        const sha256Regex = /^[a-fA-F0-9]{64}$/;
        if (sha256Regex.test(paramValue)) {
          // Create digitalData structure if it doesn't exist
          window.digitalData ??= {};
          window.digitalData.visitor ??= {};
          window.digitalData.visitor.visitorHash ??= paramValue;
          localStorage.setItem("digitalData.visitor.visitorHash", paramValue);
        } else {
          console.log('Invalid SHA-256 format');
        }
      }
    }

    function getNewsLetterSignUpEmailToHash() {
      localStorage.setItem("getNewsLetterSignUpEmailToHash", '');
      const subListId = document.querySelector('meta[name="opt.sub.list.id"]');
      if(!subListId) return;

      const formControls = Array.from(document.querySelectorAll(".umbraco-forms-form input, .umbraco-forms-form select"));
      const submit = document.querySelectorAll(".umbraco-forms-form .js-form-submit");
      
      const getFormValue = (name) => {
        const el = formControls.find(el => el.getAttribute('data-alias') === name);

        if(el) {
          return el.value;
        }

        return '';
      };

      // Get elements from form
      if(formControls && formControls.length > 0 && submit && submit.length > 0) {
        
        submit[0].addEventListener('click', (event) => {
          var userEmail = getFormValue('email');          
          const input = document.createElement('input');
          input.type = 'email';
          input.value = userEmail;

          if (input.validity.valid === true) {

            window.digitalData.visitor ??= {};
            (async () => {
              const result = await hash(userEmail);
              localStorage.setItem("digitalData.visitor.visitorHash", result);
              
            })();
          }

        });
      }
    } 

    async function hash(string) {
      const utf8 = new TextEncoder().encode(string);
      return crypto.subtle.digest('SHA-256', utf8).then((hashBuffer) => {
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray
          .map((bytes) => bytes.toString(16).padStart(2, '0'))
          .join('');
        return hashHex;
      });
    }

    function cleanArrayToString(array) {
      const regexComma = /,/g;
      return array.length ? array.toString().replace(regexComma, '|') : '';
    }


    function observeCategory(config) {

      // Id 'button-category'  class 'active' dissappear    action
      const categoryNode = document.getElementById('button-category');

      // callback function to execute when mutations are observed
      const categoryCallback = function (mutationsList, observer) {
        // console.log('categoryCallback mutation observed');

        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === "class") {
            // if class change

            // Watch for subcategories close before tracking 'searchFilter'
            if (!mutation.target.classList.contains('active')) {

              const oldData = Object.assign({}, window.digitalData?.search);

              getCategories(oldData);
              getSubCategories();

              // console.log('try observeSubCategory() in categoryCallback ');
              // will only create a subCategory observer if there is none yet
              observeSubCategory(config);

              const newData = window.digitalData?.search;
              // console.log('oldData_', oldData);
              // console.log('newData_', newData);

              trackSearchFilterChange(newData, oldData);

            }

          }
        }
      };

      // Create an observer instance linked to the callback function
      const watchCategory = new MutationObserver(categoryCallback);

      if (categoryNode) {
        // Start observing the target node for configured mutations
        watchCategory.observe(categoryNode, config);
      }

    }


    function observeSubCategory(config) {
      const searchFiltersTrayNode = document.getElementById('search-filters-tray');
      // Id 'button-subcategory'  class 'active' dissappear    action
      const subCategoryNode = document.getElementById('button-subcategory');

      const subCategoryCallback = function (mutationsList, observer) {
        // console.log('subCategoryCallback');

        for (const mutation of mutationsList) {
          debugLog('mutation.attributeName: ', mutation.attributeName)
          if (mutation.type === 'attributes' && (mutation.attributeName === "class" || mutation.attributeName === "data-selected")) {
            // if class change
            if (!mutation.target.classList.contains('active')) {

              const oldData = Object.assign({}, window.digitalData?.search);  // only does a shallow copy

              getSubCategories();

              const newData = window.digitalData?.search;
              // console.log('oldData: ', oldData);
              // console.log('newData: ', newData);

              trackSearchFilterChange(oldData, newData);

            }
          }
        }

      };

      // start observer if there is none
      if (!watchSubCategory && subCategoryNode) {
        // console.log('watchSubCategory: ', watchSubCategory);
        watchSubCategory = new MutationObserver(subCategoryCallback);
        const watchSearchFiltersTray = new MutationObserver(subCategoryCallback);
        // Start observing the target node for configured mutations
        watchSubCategory.observe(subCategoryNode, config);
        // console.log('watchSubCategory: ', watchSubCategory);
        watchSearchFiltersTray.observe(searchFiltersTrayNode, config);
      }

      // remove observer if element not present
      if (watchSubCategory && !subCategoryNode) {
        console.log('watchSubCategory.disconnect()');
        watchSubCategory.disconnect();
        watchSubCategory = null;
      }

    }


    function observeSearchGrid(config) {
      // debugLog('observeSearchGrid()');
      // Id 'button-subcategory'  class 'active' dissappear    action
      const searchGridNode = document.querySelector('.search-layout__grid');

      const searchGridCallback = function (mutationsList, observer) {
        // console.warn('searchGridCallback');

        for (const mutation of mutationsList) {
          // debugLog('mutation.attributeName: ', mutation.attributeName);
          if (mutation.type === 'attributes' && mutation.attributeName === "class") {  //  (  || mutation.attributeName === "data-selected")
            // if class change
            if (!mutation.target.classList.contains('active')) {
              // console.log('mutation.target.classList', mutation.target.classList);

              // debounce by tracking last run and not adding a new run until delay has past
              const whenRecentAction = Date.now();
              if (whenPreviousAction.length) {
                if (whenRecentAction - whenPreviousAction[0] > 300) {
                  whenPreviousAction[0] = whenRecentAction;
                  debugLog('get Filter Types And Values', '');
                  let oldData = Object.assign({}, window.digitalData?.search);
                  getCategories(oldData);
                  getSubCategories();
                }
              } else {
                whenPreviousAction[0] = whenRecentAction;
                debugLog('dont run task again within 300 ms', '');
              }

            }
          }
        }

      };

      // start observer if there is none
      if (!watchSearchGrid && searchGridNode) {
        watchSearchGrid = new MutationObserver(searchGridCallback);
        // Start observing the target node for configured mutations
        watchSearchGrid.observe(searchGridNode, config);
        // console.log('observing watchSearchGrid: ', watchSearchGrid);
      }

      // remove observer if element not present
      if (watchSearchGrid && !searchGridNode) {
        console.log('watchSearchGrid.disconnect()');
        watchSearchGrid.disconnect();
        watchSearchGrid = null;
      }

    }


    function observeRegion(config) {

      const regionNode = document.getElementById('fieldset-location');

      // callback function to execute when mutations are observed
      const regionCallback = function (mutationsList, observer) {
        // console.log('regionCallback mutation observed');


        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {

            // narrow down to only mutations on 'jcf-select-search-filters__location'
            // and check if region dropdown is closed before tracking region changes.
            // A mutation is ordinarily triggered on every child element with a class/attribute change.
            if (mutation.target.classList.contains('jcf-select-search-filters__location') && !mutation.target.classList.contains('jcf-drop-active')) {
              // debugLog(':mutation.target.classList', mutation.target.classList);

              const oldData = Object.assign({}, window.digitalData?.search);

              getCategories(oldData);
              getSubCategories();
              getRegion(oldData);

              // will only create a subCategory observer if there is none yet
              observeSubCategory(config);

              const newData = window.digitalData?.search;
              // console.log('oldData_', oldData);
              // console.log('newData_', newData);

              trackSearchFilterChange(newData, oldData); // will only send data if it has changed

            }

          }
        }
      };

      // Create an observer instance linked to the callback function
      const watchRegion = new MutationObserver(regionCallback);

      if (regionNode) {
        // Start observing the target node for configured mutations
        watchRegion.observe(regionNode, config);
      }

    }


    function getSubCategories() {

      const jcfSearchFilterTypes = document.querySelector('.jcf-select-search-filters__type');
      // console.log('jcfSearchFilterTypes: ', jcfSearchFilterTypes);

      if (jcfSearchFilterTypes) {
        // console.log('getSubCategories() and search-filters__type exists');

        const selectOptions = jcfSearchFilterTypes.querySelectorAll('.jcf-option');
        // console.log('selectOptions: ', selectOptions);
        const selectedTypes = [];
        const defaultFilterValue = 'All-Subcategories';  // insert default value

        if (!window.digitalData?.search) {
          console.log('no digitalData.search.. creating');
          let category = document.querySelector('#search-filters-tray input[name="category"]');
          if (!category) {
            const oldData = {}; // Object.assign({}, window.digitalData?.search)
            getCategories(oldData);
            category = window.digitalData?.search.filterType;
          } else {
            category = category ? cleanString(capitalizeFirstLetter(category.value)) : 'DataEvents.js-error-001.';
          }

          const search = {
            'filterType': category,
            'filterValues': defaultFilterValue
          };
          // update digitalData
          window.digitalData.search = search;
        }

        window.digitalData.search.filterValues = defaultFilterValue;

        if (digitalData.search?.filterType.includes('All-Categories')) {
          digitalData.search.filterValues = 'All-Subcategories';
        } else {
          selectOptions.forEach(x => {
            if (x.classList.contains('jcf-selected')) {
              const filterValue = cleanString(x.innerText); // clean data (replace all space's and comma's)
              selectedTypes.push(filterValue);
              // console.log('selectedTypes as string: ', selectedTypes.toString())
              // update digitalData
              window.digitalData.search.filterValues = cleanArrayToString(selectedTypes);
            }
          });
        }

      }
    }


    function getCategories(oldData) {
      // console.log('category.value: ', category.value);
      // console.log('getCategories()');

      const jcfsearchCategories = document.querySelector('.jcf-select-search-filters__category');

      if (jcfsearchCategories) {

        const selectOptions = jcfsearchCategories.querySelectorAll('.jcf-option');
        // console.log('selectOptions: ', selectOptions);
        const selectedTypes = [];

        selectOptions.forEach((x) => {

          // console.log('x: ', x);
          if (x.classList.contains('jcf-selected')) {

            const selectedType = cleanString(x.innerText); // clean data (replace all space's and comma's)
            selectedTypes.push(selectedType);
            // console.log('selectedTypes as string: ', selectedTypes.toString());

            if (selectedTypes.length) {

              const digitalData = window.digitalData;

              if (!digitalData?.search) {
                // console.log('create digitalData.search');
                const search = {
                  'filterType': cleanArrayToString(selectedTypes),
                  'filterValues': 'All-Subcategories'
                };
                digitalData.search = search;
              } else {
                digitalData.search.filterType = cleanArrayToString(selectedTypes);
                //
                if (digitalData.search.filterType !== oldData.filterType
                  || digitalData.search.filterType.includes('All-Categories')) {
                  digitalData.search.filterValues = 'All-Subcategories';
                }

              }

            }

          }
        });

      }

    }

    function getRegion() {
      // console.log('getRegion()');

      const jcfsearchRegion = document.querySelector('.jcf-select-search-filters__location');

      if (jcfsearchRegion) {

        const regionEl = document.querySelector('.jcf-select-search-filters__location .jcf-select-text span');
        // if Element exists, clean data (replace all space's and comma's) else null
        const region = regionEl ? cleanString(regionEl.innerText) : null;

        if (region !== null) {

          if (!window.digitalData.search) {
            console.log('create digitalData.search');
            const search = {
              'filterRegion': region,
              'filterValues': 'All-Subcategories'
            };
            window.digitalData.search = search;
          } else {
            window.digitalData.search.filterRegion = region;
          }

        }

      }

    }

    function capitalizeFirstLetter(string) {
      return string[0].toUpperCase() + string.slice(1).toLowerCase();
    }

    function objectsShallowCompare(obj1, obj2) {
      // converts objects to strings to do a shallow comparison
      return JSON.stringify(obj1) !== JSON.stringify(obj2); // returns true or false
    }

    function trackSearchFilterChange(oldData, newData) {
      // shallow compare is useful to prevent sending data again if it hasn't changed.
      if (objectsShallowCompare(oldData, newData)) {
        // console.log('digitalData has updated');
        debugLog('digitalData.search: ', window.digitalData.search);
        // only run if NOT local development
        if (!location.hostname.includes('local') && window.digitalData.search && _satellite) {
          _satellite.track('searchFilter');
        }
      }
    }
  }
}

